module.exports = __webpack_public_path__ + "img/11.495080fd.png";